var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7431 16.3281C19.3665 14.3416 20.1644 11.8072 19.9718 9.24904C19.7791 6.69083 18.6106 4.30452 16.708 2.58362C14.8054 0.862716 12.3141 -0.0611306 9.74947 0.00314209C7.18483 0.0674148 4.74298 1.11489 2.92894 2.92894C1.11489 4.74298 0.0674148 7.18483 0.00314209 9.74947C-0.0611306 12.3141 0.862716 14.8054 2.58362 16.708C4.30452 18.6106 6.69083 19.7791 9.24904 19.9718C11.8072 20.1644 14.3416 19.3665 16.3281 17.7431L22.5861 24.0001L24.0001 22.5861L17.7431 16.3281ZM14.0001 11.0001H11.0001V14.0001H9.00009V11.0001H6.00009V9.00009H9.00009V6.00009H11.0001V9.00009H14.0001V11.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.272dc9487b9f9a684c5b96da7dc610fc.svg";
export { ForwardRef as ReactComponent };